import netlifyIdentity from "netlify-identity-widget";

export interface IdentityUser {
  id: string;
  email: string;
}

let initialized = false;

export function initIdentity(): void {
  if (initialized) return;
  netlifyIdentity.init({ locale: "en" });
  initialized = true;
}

export function currentUser(): IdentityUser | null {
  const user = netlifyIdentity.currentUser();
  if (!user) return null;
  return { id: user.id, email: user.email };
}

export function openLogin(): void {
  netlifyIdentity.open("login");
}

export function logout(): void {
  netlifyIdentity.logout();
}

export function onAuthChange(cb: () => void): () => void {
  netlifyIdentity.on("login", cb);
  netlifyIdentity.on("logout", cb);
  netlifyIdentity.on("init", cb);
  return () => {
    netlifyIdentity.off("login", cb);
    netlifyIdentity.off("logout", cb);
    netlifyIdentity.off("init", cb);
  };
}

interface UserWithJwt {
  jwt: (forceRefresh?: boolean) => Promise<string>;
}

/**
 * Returns a fresh (auto-refreshed) JWT, or null if signed out.
 * `jwt()` exists on the real netlify-identity-widget User at runtime but is
 * missing from @types/netlify-identity-widget — cast rather than fight the
 * community types.
 */
export async function getToken(): Promise<string | null> {
  const user = netlifyIdentity.currentUser();
  if (!user) return null;
  return (user as unknown as UserWithJwt).jwt();
}
